import MerchantOrTeamBlockedInfo from 'components/merchant-or-team-blocked/MerchantOrTeamBlockedInfo';
import { selectIsActionsBlocked } from 'containers/app/appSlice';
import ExternalCompanySettings from 'containers/settings/external-company-settings/ExternalCompanySettings';
import { useAppSelector } from 'hooks';
import React, { FC } from 'react';

const ExternalCompanyPage: FC = () => {
  const isActionsBlocked = useAppSelector(selectIsActionsBlocked);

  return isActionsBlocked ? (
    <MerchantOrTeamBlockedInfo title="External Company Settings" />
  ) : (
    <ExternalCompanySettings />
  );
};

export default ExternalCompanyPage;
